import { NavigationGuardNext, Route } from 'vue-router';
import { TokenData } from '@/shared/local.storage.utils';

export function beforeEachGuard(to: Route, from: Route, next: NavigationGuardNext) {
  const token = TokenData();

  console.groupCollapsed('Router guard');
  console.log(`  from= name: ${from.name}, path: ${from.path}`);
  console.log(`    to= name: ${to.name}, path: ${to.path}`);
  console.log(` TOKEN= ${token ? 'authid: ' + token.authid + ', isadmin: ' + token.isadmin : 'null'}`);

  let redirect: any = null;

  if (!['adminlogin', 'signup', 'errors'].includes(to.name ? to.name : '')) {
    if (!token) {
      redirect = {name: 'adminlogin'};
    }
  }

  if (redirect) {
    console.log(`Redirect to :`, redirect);
  }
  console.groupEnd();
  if (redirect === null) {
    next();
  } else {
    next(redirect);
  }
}
